
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderHoursContext } from '../context/OrderHoursContext';

// Définir les animations CSS
const animations = `
  @keyframes slideDown {
    0% { transform: translateY(-100%); }
    100% { transform: translateY(0); }
  }
  @keyframes slideUp {
    0% { transform: translateY(0); }
    100% { transform: translateY(-100%); }
  }
`;

const StatusBar = () => {
  const { t } = useTranslation();
  const { isOpen, message } = useContext(OrderHoursContext);
  const [isVisible, setIsVisible] = useState(false);
  const [animationState, setAnimationState] = useState('slideDown');

  // Journaliser les valeurs du contexte pour le débogage
  useEffect(() => {
    console.log('[StatusBar] Contexte :', { isOpen, message });
  }, [isOpen, message]);

  // Gérer la visibilité selon isOpen
  useEffect(() => {
    console.log('[StatusBar] isOpen changé :', isOpen);
    setIsVisible(true);
    setAnimationState('slideDown');

    let hideTimeout;
    if (isOpen) {
      // Restaurant ouvert : cacher après 5 secondes
      hideTimeout = setTimeout(() => {
        console.log('[StatusBar] Déclenchement de slideUp');
        setAnimationState('slideUp');
        // Attendre la fin de l'animation slideUp (0.5s)
        setTimeout(() => {
          setIsVisible(false);
          console.log('[StatusBar] Barre cachée');
        }, 500);
      }, 5000); // 5 secondes
    }

    // Nettoyer le timeout
    return () => {
      if (hideTimeout) clearTimeout(hideTimeout);
    };
  }, [isOpen]);

  if (!isVisible) return null;

  return (
    <>
      <style>{animations}</style>
      <div
        className={`fixed top-0 left-0 right-0 ${isOpen ? 'bg-green-600' : 'bg-red-600'} text-white p-1 text-center shadow-lg z-[2000] rounded-xl`}
        style={{ animation: `${animationState} 0.5s ease-out forwards` }}
      >
        <p className="text-sm font-semibold truncate">{t(message)}</p>
      </div>
    </>
  );
};

export default StatusBar;